<template>
  <div class="card">
    <h1>{{ $t('ProductInfo.historical_usage_per_day') }}</h1>
    <div class="chart-wrapper">
      <ApexChart type="line" :options="options" :series="processedSeries" class="chart"/>
    </div>

    <div style="font-size:10px;">
      {{ $t('ProductInfo.historical_usage_graph_description') }}
    </div>
  </div>
</template>

<script>
import ApexCharts from "vue-apexcharts";
import {mapGetters, mapState} from "vuex";
import {colors} from "@/config";
import user from "@/api/user";
// import {user} from "src/api";

export default {
  name: "DashCartridgeUsage",
  components: {
    ApexChart: ApexCharts,
  },


  data() {
    return {
      startDate: (() => {
        const now = new Date()
        now.setDate(now.getDate() - 14);
        return now
      })(),
      isLocked: false,
      highestValue: 1.0,
      seriesData: [0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0], // source can be props
      options: {
        theme: {
          monochrome: {
            enabled: true,
            color: colors.main,
          },
        },

        tooltip: {
          fillSeriesColor: true,
          theme: 'dark'
        },
        chart: {
          toolbar: {
            show: true, // Enable toolbar for zoom functionality

            tools: {
              zoom: false,
              pan: false,
              selection: false,
            }
          },
          id: "vuechart",
          zoom: {
            enabled: true,
            type: "x", // Enable zooming on the x-axis
            autoScaleYaxis: true, // Auto scale y-axis when zooming
          },
          defaultLocale: "zh",
          locales: [
            {
              name: "en",
              options: {
                months: [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ],
                shortMonths: [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ],
                days: [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                toolbar: {
                  download: this.$t("ProductInfo.download_svg"),
                  selection: this.$t("ProductInfo.selection"),
                  selectionZoom: this.$t("ProductInfo.selectionZoom"),
                  zoomIn: this.$t("ProductInfo.zoomIn"),
                  zoomOut: this.$t("ProductInfo.zoomOut"),
                  pan: this.$t("ProductInfo.pan"),
                  reset: this.$t("ProductInfo.reset"),
                },
              },
            },
            {
              name: "zh",
              options: {
                months: [
                  "一月",
                  "二月",
                  "三月",
                  "四月",
                  "五月",
                  "六月",
                  "七月",
                  "八月",
                  "九月",
                  "十月",
                  "十一月",
                  "十二月"
                ],
                shortMonths: [
                  "01-",
                  "02-",
                  "03-",
                  "04-",
                  "05-",
                  "06-",
                  "07-",
                  "08-",
                  "09-",
                  "10-",
                  "11-",
                  "12-"
                ],
                days: [
                  "星期日",
                  "星期一",
                  "星期二",
                  "星期三",
                  "星期四",
                  "星期五",
                  "星期六"
                ],
                shortDays: [
                  "周日",
                  "周一",
                  "周二",
                  "周三",
                  "周四",
                  "周五",
                  "周六"
                ],
                toolbar: {
                  download: this.$t("ProductInfo.download_svg"),
                  selection: this.$t("ProductInfo.selection"),
                  selectionZoom: this.$t("ProductInfo.selectionZoom"),
                  zoomIn: this.$t("ProductInfo.zoomIn"),
                  zoomOut: this.$t("ProductInfo.zoomOut"),
                  pan: this.$t("ProductInfo.pan"),
                  reset: this.$t("ProductInfo.reset"),
                },
              },
            },
          ],
          // events: {
          //   mounted: function (chartContext, config) {
          //     // Move to the last data point after the chart is mounted
          //     const series = chartContext.w.globals.series[0];
          //     const lastIndex = series.length - 1;
          //     const lastDate = chartContext.w.globals.seriesX[0][lastIndex];
          //     chartContext.zoomX(lastDate - 7 * 24 * 60 * 60 * 1000, lastDate); // View the last 7 days
          //   }
          // }
        },
        xaxis: {
          type: "datetime", // Use datetime for x-axis
          labels: {
            format: "MMM dd", // Format labels as month day
            style: {
              colors: colors.main,
            },
          },
          // min: new Date("2024-06-01").getTime(), // Default to start of the data range
          // max: new Date("2024-06-07").getTime(),
        },
        yaxis: {
          min: 0,
          max: this.calculateYAxisMax(1.0), // Initial maximum
          labels: {
            style: {
              colors: colors.main,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
      },
    };
  },

  computed: {
    ...mapGetters("user", ["loggedIn"]),
    processedSeries() {
      return [
        {
          name: "Pod",
          data: this.seriesData.map((value, index) => [
            this.getStartDate(index).getTime(),
            parseFloat(value.toFixed(2)),
          ]),
        },
      ];
    },
  },
  methods: {
    showUsage() {
      // if (!this.loggedIn) {
      //   this.$router.push('/auth/login')
      //   return
      // }
      this.isLocked = false;
      // this.options.xaxis.labels.style.colors = colors.dark;
      // this.options.yaxis.labels.style.colors = colors.dark;

      // this.options = Object.assign({}, this.options);
    },
    calculateYAxisMax(highestValue) {
      // Add 0.2 to the highest value and round to nearest 0.2
      return Math.ceil((highestValue + 0.2) * 5) / 5;
    },
    updateYAxis() {
      const maxDataValue = Math.max(...this.seriesData);
      // const newMax = this.calculateYAxisMax(maxDataValue);
      this.options.yaxis.max = newMax;
      this.highestValue = maxDataValue;
      this.options = Object.assign({}, this.options); // Force update
    },

    getStartDate(offset = 0) {
      const startDate = new Date(this.startDate.getTime()); // Starting date
      startDate.setDate(startDate.getDate() + offset);
      return startDate;
    },

    getLastFourteenDays() {
      function formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      const dates = [];
      const today = new Date();

      for (let i = 0; i < 14; i++) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        dates.push(formatDate(date));
      }

      return dates;
    },
  },
  async mounted() {
    //
    if (this.loggedIn) {
      const recentTimeUsagesResp = await user.recentTimeUsages()
      const data = recentTimeUsagesResp.data;
      const time = data.map(item => item.time)
      const seconds = data.map(item => item.numberOfCartridges)
      const min = new Date(`2024-${time[0]}`)
      const max = new Date(`2024-${time[time.length - 1]}`)
      this.startDate = min;
      this.options.xaxis.min = min.getTime()
      this.options.xaxis.max = max.getTime()
      // this.series[0].data = seconds
      // this.options = Object.assign({}, this.options)
      this.seriesData = [...seconds]
    } else {
      const dates = this.getLastFourteenDays()
      this.options.xaxis.min = new Date(dates[dates.length - 1]).getTime()
      this.options.xaxis.max = new Date(dates[0]).getTime()
    }
    this.updateYAxis(); // Update y-axis scale when component is mounted
  }
};
</script>

<style scoped lang="less">
.card {
  & > * + * {
    margin-top: 0.75rem;
  }

  h1 {
    font-size: clamp(10px, 1vw, 12px);
    font-weight: bold;
  }
}

.chart {
  width: 100%;

  &-opacity-30 {
    opacity: 30%;
  }

  &-opacity-100 {
    opacity: 100%;
  }

  &-wrapper {
    height: auto;
    position: relative;
  }

  &-lock {
    position: absolute;

    padding: 1px 3px;
    display: flex;
    align-items: center;
    column-gap: 4px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.1);
    cursor: pointer;

    p {
      text-align: center;
      font-size: clamp(12px, 1vw, 14px);
    }
  }
}

.card {
  padding: 12px;
  background: #222222;
  margin: 10px 0;
}

::v-deep .apexcharts-tooltip {
  background: #f3f3f3;
  color: black;
}

::v-deep #apexchartsvuechart > div.apexcharts-toolbar > div.apexcharts-menu.apexcharts-menu-open {
  color: #282828;
}
</style>
